import { ReactNode } from "react";
import { motion } from "framer-motion";

export interface InsightProps {
  eyebrow?: string;
  title: string;
  children: ReactNode;
  accent?: string;
}

/** Lightweight content section used by every lesson body. */
export function Insight({ eyebrow, title, children, accent = "#f59e0b" }: InsightProps) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="mx-auto w-full max-w-6xl px-4 py-8 lg:px-8 lg:py-12"
    >
      {eyebrow && (
        <div className="mb-2 text-xs font-semibold uppercase tracking-[0.18em]" style={{ color: accent }}>
          {eyebrow}
        </div>
      )}
      <h2 className="font-display text-2xl font-bold text-nsm-ink lg:text-3xl">{title}</h2>
      <div className="prose-nsm mt-4 space-y-4">{children}</div>
    </motion.section>
  );
}

export function TwoCol({ children }: { children: ReactNode }) {
  return <div className="mt-4 grid grid-cols-1 gap-6 lg:grid-cols-2">{children}</div>;
}
